export default {
  setInventory (state, items) {
    state.items = items
  },
  setLotsList (state, items) {
    state.lots = items
  }
}
